import React from "react";
import "./LoadingSpinner.css";

const LoadingSpinner = ({ message = "Cargando..." }) => {
  return (
    <div className="loading-container">
      <div className="loading-spinner"></div>
      <p className="loading-message">{message}</p>
    </div>
  );
};

export default LoadingSpinner;
